import React from 'react'
import { useSelector } from 'react-redux'

import Column from '@amzn/meridian/column'
import Text from '@amzn/meridian/text'

import { getSelectedTool } from '@atredux/selectors/toolSelector'
import { getStoreId, getSelectedStoreId } from '@atredux/selectors/storeSelector'
import { getNotificationSheetState } from '@atredux/selectors/notificationSelector'

import './StoreSelectionRequiredModal.scss'

/**
 * Shown on Associate Entry when no store has been selected or scanned.
 * Associate Entry needs a store to display a QR code, so this prompts the user
 * to select one via the store switcher header.
 */
const StoreSelectionRequiredModal = (): React.ReactElement | null => {
    const selectedTool = useSelector(getSelectedTool)
    const currentStoreId = useSelector(getStoreId)
    const selectedStoreId = useSelector(getSelectedStoreId)
    const isNotificationsOpen = useSelector(getNotificationSheetState)

    const isAssociateEntry = selectedTool?.displayName === 'Associate Entry'
    const hasNeverScanned = !currentStoreId || currentStoreId === 'NO_CURRENT_STORE'
    const hasNoStore = hasNeverScanned && !selectedStoreId

    const open = hasNoStore && isAssociateEntry && !isNotificationsOpen

    if (!open) {
        return null
    }

    return (
        <div className="store-selection-required-overlay">
            <div className="store-selection-required-content">
                <Column spacing="400">
                    <Text type="h100">
                        Please select a store to continue.
                    </Text>
                    <Text>
                        Use the store selector at the top of the screen to choose a store.
                    </Text>
                </Column>
            </div>
        </div>
    )
}

export default StoreSelectionRequiredModal
